import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import { Consulting } from '@layouts/Consulting';
import { Awards, InternalLinking, Reviews } from '@components';
import {
	CaseStudies,
	Header,
	WeAlsoWorkWith,
	LookingForMore,
} from './components';
import { internalLinkingData } from '@store/DevOpsData';
import useReviewsQuery from '@utils/hooks/useReviewsQuery';

import * as styles from './IoT.module.scss';

export const IoT: React.FC = () => {
	const { directus } = useStaticQuery(graphql`
		query IoTReviews {
			directus {
				PageReviews(filter: { pageName: { _contains: "iot" } }) {
					Reviews {
						Reviews_id {
							quote
							reviewerName
							reviewerPosition
							link
							title
							logo {
								id
								imageFile {
									extension
									publicURL
									childImageSharp {
										gatsbyImageData
									}
								}
							}
						}
					}
				}
			}
		}
	`);
	const reviews = useReviewsQuery(directus);

	return (
		<div className="z-99 relative overflow-hidden">
			<Header />
			<Awards
				title="IoT"
				subtitle='The Internet of Things (IoT) refers to a network of physical objects-"things" - equipped with sensors, software and other technologies to connect and exchange data with other devices and systems via the Internet. '
				className="gray-bg"
				subtitleClassName="mt-3 limit-text"
				awardsGridClassName={styles.awardsGrid}
			/>
			<CaseStudies />
			<WeAlsoWorkWith />
			<LookingForMore />
			<InternalLinking className="white-bg" links={internalLinkingData} />
			{!!reviews.length && (
				<Reviews
					title="Our client says"
					reviews={reviews}
					maxWidth="1300px"
					titleClass="font-size-medium"
				/>
			)}
			<Consulting />
		</div>
	);
};
